/**
 * Make Shumway bug-for-bug compatible with Tamarin.
 */
import { Settings } from '../Settings';
export var as3Compatibility = Settings.FOLLOW_AS3_BUG;
